import { get, post } from "../request.js";

export const ApiPostLCRecord = {
  post: (obj) => {
    return post(`/plcmt/placementvoice`, obj);
  },
};

export const ApiGetLCUserLevel = {
  get: (level) => {
    return get(`/plcmt/setlevel/${level}`);
  },
};
